var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * MyBricks Opensource
 * https://mybricks.world
 * This source code is licensed under the MIT license.
 *
 * CheMingjun @2019
 * mybricks@126.com
 */
import { depValidateEntity } from '../_utils/validate';
export default {
    /** 环境发生变化 */
    '@envChanged': function (_a) {
        var data = _a.data, env = _a.env, cancelError = _a.cancelError, throwError = _a.throwError;
        if (!data.selector) {
            return;
        }
        var error = depValidateEntity({
            entities: data.selector.entities,
            newEntity: env.entity,
            fields: data.selector.fields,
            orders: data.selector.orders,
            conditions: data.selector.conditions
        });
        error ? throwError(error) : cancelError();
        data.errorMessage = error;
    },
    '@init': function (_a) {
        var data = _a.data, isAutoRun = _a.isAutoRun, setDesc = _a.setDesc;
        data.autoRun = !!(isAutoRun ? isAutoRun() : false);
        setDesc('未选择数据');
    },
    ':root': [
        {
            title: '选择',
            type: 'domain.dbSelect',
            options: function (_a) {
                var data = _a.data, input = _a.input;
                return {
                    get paramSchema() {
                        var _a, _b, _c, _d, _e;
                        var computedParams = JSON.parse(JSON.stringify((_b = (_a = input.get('params.params')) === null || _a === void 0 ? void 0 : _a.schema) !== null && _b !== void 0 ? _b : {}));
                        computedParams.properties = __assign(__assign({}, JSON.parse(JSON.stringify((_e = (_d = (_c = input.get('params.pageParams')) === null || _c === void 0 ? void 0 : _c.schema) === null || _d === void 0 ? void 0 : _d.properties) !== null && _e !== void 0 ? _e : {}))), computedParams.properties);
                        return computedParams || {};
                    },
                    get errorMessage() {
                        return data.errorMessage;
                    },
                    showPager: true,
                };
            },
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.selector;
                },
                set: function (_a, val) {
                    var data = _a.data, setDesc = _a.setDesc, outputs = _a.outputs, cancelError = _a.cancelError;
                    var outputSchema = val.outputSchema, otherVal = __rest(val, ["outputSchema"]);
                    data.selector = otherVal;
                    data.errorMessage = '';
                    cancelError();
                    if (data.selector) {
                        setDesc("\u5DF2\u9009\u62E9 ".concat(data.selector.desc));
                        outputs.get('rtn').setSchema(outputSchema);
                    }
                    else {
                        setDesc('未完成选择');
                    }
                }
            }
        },
    ]
};
